<div class="tr-wrapper">
  <div class="tr flex flexJustift--start flexAlign--center pr-0100"
       [ngClass]="{'expanded': anyExpanded}">
    <div class="tc trContact__title pt-0050">
      <app-entity-avatar [assessmentLevel]="connectedToEntity.currentAssessmentLevel || 0"
                         [spotlightIcon]="connectedToEntity.spotlightIcon"
                         [entityTypeId]="connectedToEntity.entityTypeId"
                         size="xs">
      </app-entity-avatar>
      <div class="pl-0025 trContact__name">
        <button type="button"
                class="mimic-link txt-15"
                appStopClickBubble
                (click)="onViewProfileClicked(connectedToEntity.id)">{{connectedToEntity | fullName}}
        </button>
        <app-highlighted-topline [targetType]="'EntityConnection'"
                                 [targetId]="entityConnection?.id"
                                 [campaignId]="campaignId"
                                 [parentEntityId]="entityId"
                                 [topline]="entityConnection.appliedToplines.item0">
        </app-highlighted-topline>
      </div>
    </div>
    <div class="tc tc--40 tc--xs">
      <div class=" trContact__notes">
        <button class="mimic-link txt-14 c-pointer"
                *ngIf="entityConnection.notes.length === 0"
                type="button"
                appStopClickBubble
                (click)="notesClicked()">
          <span>Add Note</span>
        </button>

        <ng-container *ngIf="entityConnection.notes?.length > 0">
          <button class="mimic-link txt-14 c-pointer"
                  *ngIf="!notesExpanded"
                  type="button"
                  appStopClickBubble
                  (click)="notesClicked()">
            <span>View Notes ({{entityConnection.notes?.length}})</span>
          </button>

          <button class="mimic-link txt-14 c-pointer active"
                  *ngIf="notesExpanded"
                  type="button"
                  appStopClickBubble
                  (click)="this.notesExpanded = false">
            <span>Hide Notes ({{entityConnection.notes?.length}})</span>
          </button>
        </ng-container>
      </div>

      <div class="trContact__notes trContact__add-info">
        <button class="mimic-link txt-14 c-pointer"
                *ngIf="!infoExpanded"
                type="button"
                appStopClickBubble
                (click)="this.infoExpanded = true">
          <span>View Info ({{entityConnection.tagsCount}})</span>
        </button>

        <button class="mimic-link txt-14 c-pointer active"
                *ngIf="infoExpanded"
                type="button"
                appStopClickBubble
                (click)="this.infoExpanded = false">
          <span>Hide Info ({{entityConnection.tagsCount}})</span>
        </button>
      </div>
      <div class="ml-auto mr-0 mr-0100--md w-auto trContact__meta color--red"
           *ngIf="!entityConnection.active">
        <em>Inactive</em>
      </div>
    </div>
    <div class="tc trContact__controls ml-auto right">
      <button type="button"
              appStopClickBubble
              class="mat-menu-trigger drawer__btn"
              [matMenuTriggerFor]="connectionMenu">
        <i class="far fa-fw fa-ellipsis-h"></i>
      </button>
      <mat-menu #connectionMenu="matMenu">
        <button mat-menu-item
                *ngIf="entityConnection.active"
                (click)="updateStatus(false)">
          Mark as inactive
        </button>
        <button mat-menu-item
                *ngIf="!entityConnection.active"
                (click)="updateStatus(true)">
          Mark as active
        </button>
        <button mat-menu-item
                (click)="deleteConnection()"
                class="link--red">
          <span class="link link--noline link--red">Delete connection</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="tr--expansion p-0100 bg-color--gray--000"
       *ngIf="notesExpanded && entityConnection.notes.length > 0">
    <div class="mb-0100">
      <strong style="font-size: 1.2em"
              class="color--gray">Notes</strong>
      <button class="mimic-link active txt-14 c-pointer float-r"
              type="button"
              (click)="openAddNotesDialog()">
        <i class="fa-plus fal mr-0050"></i><span>Add Note</span>
      </button>
    </div>

    <app-view-notes class="app-view-notes"
                    [noteCampaignId]="campaignId"
                    [notes]="entityConnection.notes"
                    [targetType]="'EntityConnection'"
                    [targetId]="entityConnection.id"
                    class="col__"></app-view-notes>
  </div>
  <div class="tr--expansion p-0100 bg-color--gray--000"
       *ngIf="infoExpanded">
    <div class="mb-0100">
      <strong style="font-size: 1.2em"
              class="color--gray">Connection Info</strong>
      <button class="mimic-link active txt-14 c-pointer float-r"
              type="button"
              (click)="openAddConnectionInfoDialog()">
        <i class="fa-plus fal mr-0050"></i><span>Add Connection Info</span>
      </button>
    </div>
    <app-entity-connection-lazy-content [campaignId]="campaignId"
                                        [entityConnectionId]="entityConnection.id">
    </app-entity-connection-lazy-content>
  </div>
</div>
